import styles from '../styles/skills.module.css';
import Logos from './logos';

const Skills = () => {

  return (
    <div className={styles.skills}>
      <h2>My Skills</h2>
      <Logos />
    </div>
  )
}

export default Skills;
